module.exports = __webpack_public_path__ + "static/media/error.f47dd8a1.png";